<ng-container *ngIf="form" [formGroup]="form">
    <label class="block mb-2 font-medium">{{ label }}</label>

    <input
        [id]="id + '-picker'"
        #fileInput
        type="file"
        class="hidden"
        [accept]="accept"
        [multiple]="multiple"
        (change)="onFileChange($event)" />

    <div
        *ngIf="enableDropzone"
        [attr.data-katalon-id]="id + '-dropzone'"
        class="mb-3 border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors"
        [ngClass]="{'border-primary bg-primary-50 dark:bg-primary dark:bg-opacity-5': isDragging, 'border-gray-300': !isDragging}"
        (click)="openPicker(fileInput)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">

        <ng-container *ngIf="hasPreview; else noPreviewState">
            <img [id]="id + '-preview'" class="mx-auto w-24 h-24 rounded-full object-cover" [src]="resolvedPreviewUrl" alt="Selected file preview" />
            <div class="mt-3 text-secondary">{{ selectedDropText }}</div>
        </ng-container>

        <ng-template #noPreviewState>
            <div class="text-secondary">{{ selectedFileName || emptyDropText }}</div>
        </ng-template>
    </div>

    <div *ngIf="control?.invalid" [id]="id + '-error'" class="mb-2 text-sm text-red-500">
        {{ errorMessage }}
    </div>

    <div class="mb-2 flex items-center gap-3">
        <button [id]="id + '-choose-button'" type="button" mat-stroked-button [disabled]="readonly" (click)="openPicker(fileInput)">
            {{ buttonLabel }}
        </button>

        <button
            [id]="id + '-remove-button'"
            type="button"
            mat-stroked-button
            *ngIf="selectedFileName"
            [disabled]="readonly"
            (click)="clearSelection()">
            Remove
        </button>

        <mat-spinner *ngIf="isUploading" [id]="id + '-uploading'" diameter="20"></mat-spinner>
    </div>
</ng-container>